define([
    "jquery",
    "underscore",
    "marionette",
    "forms/account/additional_account_form",
    "behaviors/form_errors_behavior",
    "behaviors/signature_behavior",
    "models/account/tc_model",
    "backbone.syphon",
], function ($, _, Marionette, AdditionalAccountForm, FormErrorsBehavior, SignatureBehavior, TcModel) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            signature: {
                behaviorClass: SignatureBehavior
            }
        },

        ui: {
            'submitBtn': '#submit_btn',
            'checkTerms': '#terms_chk',
            'checkWarning': '#warning_chk',
            'tcSignature': '#tc_signature',
            'tcSignatureData': '#tc_signature_data',
            'hiddenCheckBonus': '#hidden_check_bonus',
            'hiddenCheckTc': '#hidden_check_tc',
            'hiddenCheckComplianceTc': '#hidden_check_compliance_tc',
            'hiddenTcSignatureData': '#hidden_signature_data',
            'hiddenIsSimple': '#hidden_is_simple',
            'modalValidate': '#modal_validate',
            'modalClose': '#modal_close',

            'accountType': '#account_type',
            'currencyCd': '#currency_cd',
            'currencyAbbr': '#currency_abbr',
            'currencies': '#currencies',
            'leverage': '#leverage',
            'leverages': '#leverages',
            'promotions': '#promotions',
            'promotionCd': '#promotion_cd',
            'promotionCdWrapper': '#promotion_cd_wrapper',
            'memberTypes': '#member_types',
            'memberTypeCd': '#member_type_cd',

            'hold_on_overlay': '#holdon-overlay',

            'newSelectBox': ".new-select-box",
            'newSelectBoxLabel': ".new-select-box > div",
            'newSelectBoxImage': ".new-select-box > img",

            'newSelectBoxClick': ".dropdown-wrapper li",

            'eyeBtn': '.show_password_btn_img',

            'promotionInfoDiv': '.promotion_info_div',

            'passwordInput': "#password",
            'confirmPasswordInput': "#confirm_password",
        },

        events: {
            'click @ui.submitBtn': 'submit',
            'click @ui.eyeBtn': 'triggerEyeBtn',
            'change @ui.memberTypeCd': function (e) {
                this.requestSelects('both')
            },
            'change @ui.promotionCd': function () {
                this.requestSelects('currencies')
            },
            'change @ui.currencyCd': function () {
                this.requestSelects('promotions')
            },
            "click @ui.newSelectBox": function (e) {
                this.displaySorterSelectBox(e);
            },
            "click @ui.newSelectBoxLabel": function (e) {
                this.unDisplaySelectBox(e);
                this.displaySorterSelectBoxByLabel(e);
            },
            "click @ui.newSelectBoxImage": function (e) {
                this.displaySorterSelectBoxByImage(e);
            },
            "click @ui.newSelectBoxClick": function (e) {
                this.changeLabel(e);
                this.changeInputVal(e);
            },
            "click": function (e) {
                if (e.target.id === 'content_layout') {
                    this.unDisplaySelectBox(e);
                }
            },
            "keyup @ui.passwordInput": "passwordValidation",
            "keyup @ui.confirmPasswordInput": "isSamePasswordValidation",
        },

        initialize: function () {
            this.bindUIElements();
            this.promotionLeverageList = [];
            this.requestSelects('both', true)
        },

        passwordValidation: function (e) {
            let password = e.target.value;
            let errorFound = false;

            // 글자수 8자 이상, 15자 이하
            let lengthRule = /^.{8,15}$/;
            if (lengthRule.test(password)) {
                document.getElementsByClassName("length")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("length")[0].style.display = "flex";
            }

            // 숫자 하나 이상 포함
            let digitRule = /\d/;
            if (digitRule.test(password)) {
                document.getElementsByClassName("number")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("number")[0].style.display = "flex";
            }

            // 특수문자 하나 이상 포함
            let specialCharRule = /[!@#$%^*+=-]+/;
            if (specialCharRule.test(password)) {
                document.getElementsByClassName("special-character")[0].style.display =
                    "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("special-character")[0].style.display =
                    "flex";
            }

            // 염문 대문자/소문자 포함
            let uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
            if (uppercaseRule.test(password)) {
                document.getElementsByClassName("uppercase")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("uppercase")[0].style.display = "flex";
            }

            if (errorFound) {
                document.getElementsByClassName("first-validation-box")[0].style.display =
                    "flex";
            } else {
                document.getElementsByClassName("first-validation-box")[0].style.display =
                    "none";
            }
        },

        isSamePasswordValidation: function (e) {
            let passwordForConfirm = e.target.value;
            if (
                document.getElementById("password").value === passwordForConfirm
            ) {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "none";
            } else {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "flex";
            }
        },

        // Different promotions have different available leverages, let's update it here.
        updateLeverageList: function (isInit = false) {
            let optionsString = "";

            if (isInit) {
                promotionList = window.init_leverage
            } else {
                promotionList = this.promotionLeverageList;
            }

            this.ui.leverages.html("");
            _.each(promotionList, function (item, index) {
                optionsString += "<li data-value='" + item.leverage + "'>" + item.leverageName + "</li>";
            });
            this.ui.leverages.append(optionsString);

            this.ui.leverage.val(this.ui.leverages.find('li').last().data('value'))
            const divLabel = this.ui.leverages.parent().find('div').first();
            divLabel.html(this.ui.leverages.find('li').last().html())
        },

        // Different member type have different available currencies, let's update it here.
        updateCurrencyList: function (currenciesList, isInit) {
            let optionsString = "";

            let selectedValue = this.ui.currencyCd.val();

            this.ui.currencies.html("");
            _.each(currenciesList, function (item, index) {
                optionsString += "<li data-value='" + item.currencyCd + "'>" + item.currencyAbbr + "</li>";
            });
            this.ui.currencies.append(optionsString);

            // olympic promotion
            if (isInit == true && window.is_olympic_promo == 'yes') {
                const olympicLI = this.ui.currencies.find('li[data-value=' + window.olympic_promotion.currency_cd + ']')

                if (olympicLI.length > 0) {
                    this.ui.currencyCd.val(window.olympic_promotion.currency_cd)
                    this.ui.currencyAbbr.html(window.olympic_promotion.currency_abbr)
                    return;
                }

            }

            if (this.ui.currencies.find('li[data-value=' + selectedValue + ']').length > 0) {
                this.ui.currencyCd.val(selectedValue)
            } else {
                this.ui.currencyCd.val(this.ui.currencies.find('li').first().data('value'))
                this.ui.currencyAbbr.html(this.ui.currencies.find('li').first().html())
            }
        },

        updatePromotionList: function (promotionsList, isInit = false) {
            if (_.isEmpty(promotionsList)) {
                this.ui.promotionInfoDiv.hide()
                return;
            } else {
                this.ui.promotionInfoDiv.show()
            }

            let optionsString = "";

            // Populate the dropdown
            this.ui.promotions.html("");
            this.ui.promotions.append("<li data-value=''> - </li>");
            _.each(promotionsList, function (item, index) {
                optionsString += "<li data-value='" + item.promotionCd + "'>" + item.promotionName + "</li>";
            });
            this.ui.promotions.append(optionsString);

            // olympic promotion
            if (isInit == true && window.is_olympic_promo == 'yes') {
                const olympicLI = this.ui.promotions.find(`li[data-value="${window.olympic_promotion.promotion_cd}"]`);
                if (olympicLI.length > 0) {
                    this.ui.promotionCd.val(window.olympic_promotion.promotion_cd)
                    const divLabel = this.ui.promotions.parent().find('div').first();
                    divLabel.html(window.olympic_promotion.promotion_name)
                    return;
                }
            }

            // default promotion
            if (isInit == true && window.has_default_promotion == 'yes') {
                const default_promotion_li = this.ui.promotions.find(`li[data-value="${window.default_promotion_cd}"]`);

                if (default_promotion_li.length > 0) {
                    this.ui.promotionCd.val(window.default_promotion_cd)
                    const divLabel = this.ui.promotions.parent().find('div').first();
                    divLabel.html(window.default_promotion_name)
                    return;
                }
            }

            this.ui.promotionCd.val(this.ui.promotions.find('li').first().data('value'))
            const divLabel = this.ui.promotions.parent().find('div').first();
            divLabel.html(this.ui.promotions.find('li').first().html())
        },

        updateMemberTypeDiv: function (isInit = false) {
            if (isInit == true && window.is_olympic_promo == 'yes') {
                const olympicLI = this.ui.memberTypes.find(`li[data-value="${window.olympic_promotion.member_type_cd}"]`);

                if (olympicLI.length > 0) {
                    this.ui.memberTypeCd.val(window.olympic_promotion.member_type_cd)
                    const divLabel = this.ui.memberTypes.parent().find('div').first();
                    divLabel.html(window.olympic_promotion.member_type_name)
                }
            }
        },

        requestSelects: function (keyToUpdate = 'both', isInit = false) {
            if (window.has_forced_selects == 1) {
                return;
            }

            let that = this;

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            requestBody = {
                'member_type_cd': this.ui.memberTypeCd.val(),
                'currency_abbr': this.ui.currencyAbbr.html(),
            }

            // olmypic promotion
            if (isInit == true && window.is_olympic_promo == 'yes') {
                requestBody = {
                    'member_type_cd': window.olympic_promotion.member_type_cd,
                    'currency_abbr': window.olympic_promotion.currency_abbr,
                    'promotion_cd': window.olympic_promotion.promotion_cd
                }
            }

            if ((keyToUpdate != 'promotions' && keyToUpdate != 'both')
                || (isInit == true && window.has_default_promotion == 'yes')
            ) {
                requestBody['promotion_cd'] = this.ui.promotionCd.val()
            }

            $.ajax('/rest_account/selects_list', {
                method: "GET",
                data: requestBody,
                success: function (data) {
                    // Display/Hide Dropdown
                    if (keyToUpdate == 'currencies') {
                        that.updateCurrencies(that, data, isInit)
                    } else if (keyToUpdate == 'promotions') {
                        that.updatePromotions(that, data, isInit)
                    } else {
                        that.updatePromotions(that, data, isInit)
                        that.updateCurrencies(that, data, isInit)
                    }

                    that.updateMemberTypeDiv(isInit)

                    HoldOn.close();
                }
            })
        },

        updatePromotions: function (that, data, isInit = false) {
            that.promotionLeverageList = data["leverages"];
            if (!_.isEmpty(data["promotions"])) {
                that.updateLeverageList(isInit);
                that.updatePromotionList(data["promotions"], isInit);
                that.ui.promotionCdWrapper.show();
            } else {
                that.updatePromotionList([], isInit);
                that.ui.promotionCd.val("");
                that.ui.promotionCdWrapper.hide();
                that.updateLeverageList(isInit);
            }
        },

        updateCurrencies: function (that, data, isInit = false) {
            that.promotionLeverageList = data["leverages"];
            that.updateLeverageList();
            if (!_.isEmpty(data["currencies"])) {
                that.updateCurrencyList(data["currencies"], isInit);
            } else {
                that.updateCurrencyList([], isInit);
            }
        },

        submit: function (e) {
            e.preventDefault();
            this.ui.submitBtn.attr('disabled', true);

            this.triggerMethod('hide:errors');

            const formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
            const form = new AdditionalAccountForm();
            form.set(formData);

            const errors = form.validate();

            const that = this;
            if (_.size(errors) < 1) {
                HoldOn.open({
                    theme: "sk-fading-circle"
                });
                $("#holdon-overlay").show();
                form.validateWithServer({
                    type: 'POST',
                    success: function (model, res) {
                        that.ui.submitBtn.attr('disabled', false);
                        that.$('#form_submit').submit();
                        that.ui.submitBtn.attr('disabled', true);
                    },
                    error: function (model, error) {
                        that.ui.submitBtn.attr('disabled', false);
                        $("#holdon-overlay").hide();
                        that.triggerMethod('show:errors', error.responseJSON);
                        HoldOn.close();
                    }
                });
            } else {
                that.ui.submitBtn.attr('disabled', false);
                this.triggerMethod('show:errors', errors);
            }
        },

        displaySorterSelectBox: function (e) {
            const selectBox = $(event.target).children("ul")

            if (selectBox.css("display") === 'none') {
                $('.dropdown-wrapper').hide();
            }

            selectBox.toggle();
        },

        displaySorterSelectBoxByLabel: function (e) {
            const selectBox = $(event.target).parent().children("ul")
            selectBox.toggle();
        },

        displaySorterSelectBoxByImage: function (e) {
            const selectBox = $(event.target).parent().children("ul")

            if (selectBox.css("display") === 'none') {
                $('.dropdown-wrapper').hide();
            }

            selectBox.toggle();
        },

        changeLabel: function (e) {
            const liValue = $(event.target).html();
            const ul = $(event.target).parent();
            const selectBox = ul.parent();
            const divLabel = selectBox.children('div');
            ul.toggle();
            divLabel.html(liValue);
        },

        changeInputVal: function (e) {
            const liValue = $(event.target).data('value');
            const ul = $(event.target).parent();
            const selectBox = ul.parent();
            const input = selectBox.next('input');
            input.val(liValue).change();
        },

        unDisplaySelectBox: function (e) {
            $('.dropdown-wrapper').hide();
        },

        triggerEyeBtn: function (e) {
            const eyeBtn = $(e.currentTarget);
            const password = $(e.currentTarget).parent().parent().find('.password')
            const type = password.attr('type');
            if (type === 'text') {
                password.attr('type', 'password');
                eyeBtn.attr('src', '/assets/common/common/img/eye_icon_gray.svg');
            } else {
                password.attr('type', 'text');
                eyeBtn.attr('src', '/assets/common/common/img/hide_eye_gray.svg');
            }
        },
    });
});